import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { ISubheaderLeftSection, ISubheaderMiddleSection, ISubheaderRightSection } from './sub-header.modal';
import { SubheaderHandlerService } from '../../services/subheader-handler.service';


@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html'
})
export class SubHeaderComponent implements OnDestroy {
  leftSection: ISubheaderLeftSection;
  rightSection: ISubheaderRightSection;

  leftSectionSubscription: Subscription;
  rightSectionSubscription: Subscription;

  constructor(private subHeaderService: SubheaderHandlerService,  public router: Router) {
    this.leftSectionSubscription = subHeaderService.subheaderLeftSection$.subscribe(update => {
      this.leftSection = update;
    });
    this.rightSectionSubscription = subHeaderService.subheaderRightSection$.subscribe(update => {
      this.rightSection = update;
    });
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.leftSectionSubscription.unsubscribe();
    this.rightSectionSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/sub-header/sub-header.component.ts